<form class="se-auth-dialog-container se-flex se-expand" (ngSubmit)="closeModal(false)">
    <div class="se-flex se-vertical se-expand">
        <div class="se-dialog-header mat-elevation-z6">
            <h3 mat-dialog-title ><span> {{ title }}</span></h3>
        </div>

        <div class="se-sign-dialog-content" mat-dialog-content>
             <div class="mat-input-container">
                 <mat-form-field appearance="outline">
                     <mat-label>{{ usernameLabel }}</mat-label>
                     <input name="sign_username"
                            matInput
                            [placeholder]="'Signer'"
                            [(ngModel)]="data.comped.signerName"
                            tabindex="-1"
                            autocomplete="off"
                            readonly />
                 </mat-form-field>

                 <!-- Pin Text Box -->
                 <mat-form-field appearance="outline">
                     <mat-label>{{ pinLabel }}</mat-label>
                     <input #pin
                            name="sign_pin"
                            [type]="showPin ? 'text' : 'password'"
                            matInput
                            [placeholder]="'Pin'"
                            [(ngModel)]="data.comped.pin"
                            autocomplete="new-password"
                            required />
                     <button type="button"
                             matSuffix
                             mat-icon-button
                             aria-label="Show"
                             (click)="showPin = !showPin"
                             tabindex="-1">
                         <mat-icon>{{ showPin ? "visibility_off" : "visibility" }}</mat-icon>
                     </button>
                     @if(!!data.comped.pin){
                         <button 
                                 type="button"
                                 matSuffix
                                 mat-icon-button
                                 aria-label="Clear"
                                 (click)="data.comped.pin = ''"
                                 tabindex="-1">
                             <mat-icon>close</mat-icon>
                         </button>
                     }
                 </mat-form-field>
             </div>
        </div>
        <div class="se-sign-dialog-action-container" mat-dialog-actions>
            <button mat-button
                    color="primary"
                    class="se-dialog-action-button"
                    type="button"
                    (click)="closeModal(true)"
                    >
                <span >{{btnCancelLabel}}</span>
            </button>

            <button mat-button
                    class="se-dialog-action-button"
                    type="button"
                    color="primary"
                    [disabled]="!data.comped.pin"
                    (click)="closeModal(false)">
                <span >{{btnOkLabel}}</span>
            </button>

            <button type="submit" [disabled]="!data.comped.pin" style="display: none">hidden submit</button>
        </div>

    </div>
</form>
